import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Spinner({ size = "md", className }: { size?: "sm" | "md" | "lg"; className?: string }) {
  const s = size === "sm" ? "size-3.5" : size === "lg" ? "size-8" : "size-5";
  return <Loader2 className={cn("animate-spin text-current", s, className)} aria-hidden />;
}
